// extracted by mini-css-extract-plugin
export default {"navButtons":"AppNavigation_navButtons__X2tt1","rightBlock":"AppNavigation_rightBlock__fyBcj","versionButton":"AppNavigation_versionButton__Kl6vF"};